import type { Configuration, PopupRequest, RedirectRequest, SilentRequest } from "@azure/msal-browser";
import { getOptionalEnvArray, getOptionalEnvVar, getRequiredEnvVar } from "./utils/env";

const tenantId = getRequiredEnvVar("REACT_APP_ENTRA_TENANT_ID");
const clientId = getRequiredEnvVar("REACT_APP_ENTRA_CLIENT_ID");
const redirectUri =
  getOptionalEnvVar("REACT_APP_ENTRA_REDIRECT_URI") ?? `${window.location.origin}/auth`;
const postLogoutRedirectUri =
  getOptionalEnvVar("REACT_APP_ENTRA_POST_LOGOUT_REDIRECT_URI") ?? `${window.location.origin}/auth`;
const domainHint = getRequiredEnvVar("REACT_APP_ENTRA_DOMAIN_HINT");
const scopes =
  getOptionalEnvArray("REACT_APP_ENTRA_SCOPES") ?? [`api://${clientId}/access_as_user`];

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

const extraQueryParameters = domainHint
  ? { domain_hint: domainHint }
  : undefined;

export const loginRequest: PopupRequest = {
  scopes,
  extraQueryParameters,
};

// Used for the initial sign-in button: a full-page redirect, unlike loginRequest's
// popup, isn't subject to iOS Safari's popup-blocking/timing quirks (SIG-87).
export const loginRedirectRequest: RedirectRequest = {
  scopes,
  extraQueryParameters,
};

export const silentRequest: SilentRequest = {
  scopes,
};
